import { motion } from "framer-motion";
import styles from "./AnimatedCard.module.css";

export default function AnimatedCard({ children }) {
  return (
    <motion.div
      className={styles.card}
      whileHover={{
        y: -5,
        boxShadow: "0 8px 10px var(--card-hover-shadow)",
      }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      {children}
    </motion.div>
  );
}
